import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/th";

export default function CallModal({ isOpen, onClose, onSave, initialData }) {
  const userRole = localStorage.getItem("role");
  const isAdmin = userRole === "Admin";

  const hasResult =
    initialData?.Call_Result && initialData.Call_Result.trim() !== "";

  const canEditResult = isAdmin || !hasResult;

  // แปลงเป็น พ.ศ.
  const toBuddhist = (date) => moment(date).add(543, "year");

  const buildDateTimeDisplay = (dateStr, start, end, hasResult) => {
    if (!dateStr) return "";

    if (hasResult) {
      //  มีผลการโทรแล้ว → ใช้ Call_Date แบบเต็ม (ไม่สน Time_Start/End)
      // ตัด 'Z' ทิ้ง เพื่อไม่ให้ moment เอาไป +7 ตาม timezone
      const localLike = dateStr.replace("Z", "");
      return moment(localLike).add(543, "year").format("DD/MM/YYYY HH:mm");
    }

    // ❌ ยังไม่มีผล → ใช้เฉพาะวัน + ช่วงเวลา start-end
    const base = dateStr.split("T")[0]; // YYYY-MM-DD
    const d = toBuddhist(base).format("DD/MM/YYYY");
    return `${d} ${start || "00:00"} - ${end || "00:00"}`;
  };

  const [form, setForm] = useState({
    Sale_Emp_Name: "",
    Call_DateTime: "",
    Time_Start: "",
    Time_End: "",
    Call_Result: "",
    Call_Remark: "",
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        Sale_Emp_Name: initialData.Sale_Emp_Name || "",
        Call_DateTime: buildDateTimeDisplay(
          initialData.Call_Date,
          initialData.Time_Start,
          initialData.Time_End,
          hasResult
        ),
        Time_Start: initialData.Time_Start || "",
        Time_End: initialData.Time_End || "",
        Call_Result: initialData.Call_Result || "",
        Call_Remark: initialData.Call_Remark || "",
      });
    }
  }, [initialData, hasResult]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[2000]">
      <div className="bg-white p-6 rounded-xl shadow-xl w-[430px] min-h-[420px]">

        <h3 className="text-lg font-bold mb-4">📞 ข้อมูลการโทร</h3>

        {/* ผู้รับผิดชอบ — แสดงเฉพาะ Admin */}
        {isAdmin && (
          <div className="mb-4">
            <label className="text-sm">ผู้รับผิดชอบ</label>
            <input
              value={form.Sale_Emp_Name}
              readOnly
              disabled
              className="w-full border px-3 h-[38px] leading-[38px] bg-gray-100 rounded"
            />
          </div>
        )}

        {/* วันที่และเวลาโทร */}
        <div className="mb-4">
          <label className="text-sm">วันที่และเวลาโทร</label>
          <input
            type="text"
            value={form.Call_DateTime}
            readOnly
            disabled
            className="w-full border px-3 h-[38px] leading-[38px] bg-gray-100 rounded cursor-not-allowed"
          />
        </div>

        {/* Hidden time fields */}
        <input type="hidden" value={form.Time_Start} />
        <input type="hidden" value={form.Time_End} />

        {/* ผลการโทร */}
        <div className="mb-4">
          <label className="text-sm">ผลการโทร</label>
          <textarea
            rows={3}
            disabled={!canEditResult}
            value={form.Call_Result}
            onChange={(e) =>
              setForm({ ...form, Call_Result: e.target.value })
            }
            className={`w-full border px-3 py-2 rounded ${
              !canEditResult ? "bg-gray-100 cursor-not-allowed" : ""
            }`}
            style={{ minHeight: "70px", lineHeight: "22px" }}
          />
        </div>

        {/* หมายเหตุ */}
        <div className="mb-4">
          <label className="text-sm">หมายเหตุ</label>
          <textarea
            rows={3}
            disabled={!canEditResult}
            value={form.Call_Remark}
            onChange={(e) =>
              setForm({ ...form, Call_Remark: e.target.value })
            }
            className={`w-full border px-3 py-2 rounded ${
              !canEditResult ? "bg-gray-100 cursor-not-allowed" : ""
            }`}
            style={{ minHeight: "70px", lineHeight: "22px" }}
          />
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded text-gray-600"
          >
            ยกเลิก
          </button>

          {canEditResult && (
            <button
              onClick={() =>
                onSave(
                  "edit",
                  {
                    Call_Id: initialData?.Call_Id,
                    AR_Id: initialData?.AR_Id,
                    ServiceAddr_Id: initialData?.ServiceAddr_Id,
                    Sale_Emp_Id: initialData?.Sale_Emp_Id,
                    Sale_Emp_Name: initialData?.Sale_Emp_Name,

                    Call_Result: form.Call_Result,
                    Call_Remark: form.Call_Remark,

                    Time_Start: initialData?.Time_Start,
                    Time_End: initialData?.Time_End,

                    // ⭐ ป้องกันเวลาเพี้ยน timezone
                    Call_Date: (initialData?.Call_Date || "").replace("Z", ""),
                  },
                  initialData?.Call_Id
                )
              }
              className="px-4 py-2 bg-[#E13F57] text-white rounded"
            >
              บันทึก
            </button>


          )}
        </div>

      </div>
    </div>
  );
}
